import {
  REQUEST_CAMPAIGNS,
  CampaignActions,
  REQUEST_CAMPAIGNS_DONE
} from "./types";

import * as CampaignApi from "../../api/campaignApi";
import { Campaign } from "../../models/Campaign";
import { isOk } from "../../result";

function fetchCampaigns(campaigns: ReadonlyArray<Campaign>): CampaignActions {
  return {
    type: REQUEST_CAMPAIGNS,
    payload: campaigns
  };
}

function fetchCampaignsDone(
  campaigns: ReadonlyArray<Campaign>
): CampaignActions {
  return {
    type: REQUEST_CAMPAIGNS_DONE,
    payload: campaigns
  };
}

export const thunkFetchCampaigns = () => async (dispatch: any) => {
  try {
    dispatch(fetchCampaigns([]));
    const result = await CampaignApi.list();

    if (isOk(result)) {
      dispatch(fetchCampaignsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchCampaignsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
